export default __webpack_public_path__ + "static/media/infb.a542e5de.jpg";